export default __webpack_public_path__ + "img/booqYUQK.8e339708.svg";